import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";

@Component({
  selector: 'app-product',
  standalone: true,
  imports: [CommonModule,ImageGalleryComponent],
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss'
})
export class ProductComponent {

  public products!: { image: string }[]

ngOnInit(): void {

  this.products = [
    { 
      image:"../../assets/cone.jpg"
    },
    { 
      image:"../../assets/cylinder.jpg",
    },
    { 
      image:"../../assets/half-cylinder.jpg",
    },
    { 
      image:"../../assets/hemisphere.jpg",
    },
    { 
      image:"../../assets/hemisphere.jpg",
    },
    { 
      image:"../../assets/prism.jpg",
    },
    { 
      image:"../../assets/right.jpg",
    },
    { 
      image:"../../assets/square-pyramid.png",
    },
  ]
}
}
